/**
 * Route for Terms and Conditions (P45 U71, FSD 4.2.5.2). INT spreads `TERMS_ROUTES` into
 * `PROCUREMENT_ROUTES` (routes.ts is shared by parallel packets) and adds the nav entry
 * `proc-terms-conditions` under s-4.2.5. Literal path string (R3).
 */

import type { RouteRecordRaw } from 'vue-router'

export const TERMS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/procurement/terms-conditions',
    name: 'procurement-terms-conditions',
    component: () => import('@/modules/procurement/terms/TermsTemplatesView.vue'),
    meta: {
      titleKey: 'procurement.u71.terms.title',
      permission: 'procurement.po.read',
    },
  },
]
